// extracted by mini-css-extract-plugin
export default {"giveUsACallMobile":"PE7jLz","giveUsACallDesktop":"LwPQXg"};